var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClosedEye = function SvgClosedEye(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 16,
    "data-width-24": 24,
    viewBox: "0 0 23.6 20.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.906 19.363a.8.8 0 0 0 .106.362.816.816 0 0 0 1.447-.082l.85-1.933a9.4 9.4 0 0 0 2.443.334c5.23 0 9.61-4.73 11.25-6.76a2.23 2.23 0 0 0 0-2.82c-1.178-1.46-3.763-4.313-7.072-5.803l.671-1.526a.808.808 0 1 0-1.48-.652l-.71 1.614a9.5 9.5 0 0 0-2.659-.393c-5.25 0-9.61 4.76-11.25 6.76a2.23 2.23 0 0 0 0 2.82c1.202 1.487 3.875 4.425 7.276 5.889l-.8 1.819a.8.8 0 0 0-.072.37M9.92 16.32a7.8 7.8 0 0 0 1.832.224c4.58 0 8.58-4.34 10.08-6.21a.72.72 0 0 0 0-.92c-1.091-1.36-3.506-4.03-6.506-5.382l-.671 1.527a5.2 5.2 0 0 1-4.122 9.37zm-.882-2.01-.658 1.494c-3.092-1.32-5.592-4.079-6.708-5.47a.72.72 0 0 1 0-.92c1.5-1.87 5.5-6.21 10.08-6.21.699 0 1.384.1 2.049.279l-.613 1.393a5.2 5.2 0 0 0-4.15 9.433m2.112-.785a3.7 3.7 0 0 0 2.887-6.562zm1.426-7.258L9.65 12.918a3.7 3.7 0 0 1 2.926-6.651",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClosedEye);
export default ForwardRef;